import { Button, Modal, Nav } from 'react-bootstrap'
import * as dayjs from 'dayjs'
import BloodPressureCard from './BloodPressureCard'
import { useState, useContext } from 'react'
import ExportDataToEmail from './ExportDataToEmail'
import { AuthContext } from '../AuthContext'

const DataCollection = ({
  dataCollectionModalShow,
  setDataCollectionModalShow,
  patient_id,
}) => {
  const [yesterday, setYesterday] = useState(dayjs())
  const [lastWeek, setLastWeek] = useState(yesterday.subtract(6, 'day'))
  const [exportDataToEmailModalShow, setExportDataToEmailModalShow] =
    useState(false)
  const [edit, setEdit] = useState({ isEditing: false, date: '' })
  const { currentUser } = useContext(AuthContext)

  const handleLastWeek = () => {
    let subtractNum = 7
    setYesterday(yesterday.subtract(subtractNum, 'day'))
    setLastWeek(lastWeek.subtract(subtractNum, 'day'))
    subtractNum = subtractNum - 7
  }
  const handleNextWeek = () => {
    let addNum = 7
    setYesterday(yesterday.add(addNum, 'day'))
    setLastWeek(lastWeek.add(addNum, 'day'))
    addNum = addNum + 7
  }

  return (
    <>
      {exportDataToEmailModalShow && (
        <ExportDataToEmail
          currentUser={currentUser}
          exportDataToEmailModalShow={exportDataToEmailModalShow}
          setExportDataToEmailModalShow={setExportDataToEmailModalShow}
          patient_id={patient_id}
        />
      )}
      <Modal
        show={dataCollectionModalShow}
        dialogClassName="formModalWidth"
        className="metabolic-syndrome-form"
      >
        <div className="d-flex m-3">
          <div
            className="align-items-center h2"
            onClick={() => {
              if (!edit.isEditing) {
                setDataCollectionModalShow(false)
              } else {
                setEdit({ isEditing: false, date: '' })
              }
            }}
          >
            <i
              className="fa-solid fa-chevron-left"
              style={{ cursor: 'pointer' }}
            />
          </div>
          {!edit.isEditing ? (
            <Nav
              variant="pills"
              defaultActiveKey="bloodPressure"
              className="mx-3"
            >
              <Nav.Item>
                <Nav.Link eventKey="bloodPressure">血壓</Nav.Link>
              </Nav.Item>
            </Nav>
          ) : (
            <div
              className="m-2"
              onClick={() => {
                setEdit({ isEditing: false, date: '' })
              }}
            >
              返回血壓列表
            </div>
          )}
        </div>
        <Modal.Body
          className="d-flex flex-column
         justify-content-center align-items-center"
        >
          {!edit.isEditing && (
            <div
              className="d-flex
         justify-content-between align-items-center w-75"
            >
              <Button
                onClick={() => {
                  handleLastWeek()
                }}
              >
                <i className="fa-solid fa-caret-left me-2" />
                上一週
              </Button>
              {lastWeek.format('YYYY-MM-DD')} ~ {yesterday.format('YYYY-MM-DD')}
              <Button
                onClick={() => {
                  handleNextWeek()
                }}
                disabled={
                  yesterday.format('YYYY-MM-DD') ===
                  dayjs().format('YYYY-MM-DD')
                    ? true
                    : false
                }
              >
                下一週
                <i className="fa-solid fa-caret-right ms-2" />
              </Button>
            </div>
          )}
          {!edit.isEditing && (
            <div className="w-75 my-3 d-flex justify-content-end">
              <Button
                onClick={() => {
                  setExportDataToEmailModalShow(true)
                }}
                variant="outline-primary"
              >
                匯出資料至信箱
              </Button>
            </div>
          )}

          <BloodPressureCard
            yesterday={yesterday}
            lastWeek={lastWeek}
            edit={edit}
            setEdit={setEdit}
            patient_id={patient_id}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default DataCollection
